module.exports = __webpack_public_path__ + "img/daylight_2.ae1a04b3.png";